export default __webpack_public_path__ + "static/media/driver2.0e406e59.jpg";